import { FC } from "react";

import { emiOptions } from "./_constants";
import RangeFilter from "@/components/ui/RangeFilter";

interface EMIFilterProps {
  onFromEMIChange: (value: { value: number; label: string } | null) => void;
  onToEMIChange: (value: { value: number; label: string } | null) => void;
  onFromEMIClear: () => void;
  onToEMIClear: () => void;
  onReset: () => void;
  fromValue?: { value: number; label: string } | null;
  toValue?: { value: number; label: string } | null;
}

export const EMIFilter: FC<EMIFilterProps> = ({
  onFromEMIChange,
  onToEMIChange,
  onFromEMIClear,
  onToEMIClear,
  onReset,
  fromValue,
  toValue,
}) => {
  return (
    <RangeFilter
      options={emiOptions}
      label="Monthly Installments"
      onFromChange={onFromEMIChange}
      onToChange={onToEMIChange}
      onFromClear={onFromEMIClear}
      onToClear={onToEMIClear}
      onReset={onReset}
      fromValue={fromValue}
      toValue={toValue}
    />
  );
};
